import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getRecaptchaApiKey } from 'src/actions'
import { IRecaptchaToken, IReducer } from 'src/interface'

export const useRecaptcha = () => {
  const [recaptchaToken, setRecaptchaToken] = useState<IRecaptchaToken>(null)
  const dispatch = useDispatch()
  const recaptchaApiKey = useSelector((state: IReducer) => state.recaptchaReducer)

  useEffect(() => {
    if (!recaptchaApiKey) {
      dispatch(getRecaptchaApiKey())
    }
  }, [recaptchaApiKey, dispatch])

  const handleTokenChange = (newToken: IRecaptchaToken) => {
    setRecaptchaToken(newToken)
  }

  return {
    recaptchaToken,
    handleTokenChange
  }
}
